import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { getSurvey } from '../../../action/guestRequest'
import { sendAnalytics } from '../../../action/homeAction'
import { getDefaultAnalyticsLabel } from '../../JS/utility'
import { withTranslation } from 'react-i18next'
import { CMSPath } from '../../../config/constant'

function GdprBeforeIdAndSelfieScan(props) {

    const { t } = props;
    const [verbiage, setVerbiage] = useState([])
    const [allowProceedButton, setAllowProceedButton] = useState(false);
    const [showWarning, setShowWarning] = useState(false)
    
    useEffect(() => {
        setVerbiage(t("check_in.gdprBeforeIdAndSelfieScan.orderWiseData",{ returnObjects: true }))
      },[])
    

    const handleChangeQuestionRadio=(questionOrder, optionOrder, option)=>{

        if(option.optionType == "negative") setShowWarning(true);

        console.log(questionOrder, optionOrder, "order");

        let updatedVerbiage= [...verbiage];
        let updatedQuestion= verbiage[questionOrder - 1] ;

        updatedQuestion["questionOptions"]= updatedQuestion["questionOptions"].map(item=>{
            delete item["isSelected"];
            return item;
        })
        console.log("," , updatedQuestion)
        let updatedAnswer = updatedQuestion["questionOptions"][optionOrder - 1];
        console.log("," , updatedQuestion)
        updatedAnswer= {...updatedAnswer, isSelected:true }

        updatedQuestion["questionOptions"][optionOrder - 1] = updatedAnswer;
        updatedVerbiage[questionOrder - 1] = updatedQuestion;

        console.log(updatedVerbiage, "sjldfk")
        setVerbiage(updatedVerbiage);
    }

    useEffect(()=>{

        console.log( "testtting", t("check_in.gdprBeforeIdAndSelfieScan"),   t("check_in.gdprBeforeIdAndSelfieScan.shouldShow"))
        let someQuestionNotSelectedYet = verbiage.some((item)=>{
            if(item.type=="question" && !item["questionOptions"].some(option=>Boolean(option.isSelected))){
               return true;
            }
        })

        let someMandatoryOptionNotSelected=  verbiage.some((item)=> item.type=="question" && item["questionOptions"].some( option=> option.isThisOptionMandatoryToProceed && !option.isSelected ));

        console.log(someQuestionNotSelectedYet, "someQuestionNotSelectedYet")

        setAllowProceedButton( !Boolean(someQuestionNotSelectedYet || someMandatoryOptionNotSelected ));
        
    },[verbiage])
 
  return (
    <div class="main-container" >
		<header class="inner-pages w-footer subpages">
			<a onClick={props.goBack} class="button-back"></a>
			<div class="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
				{/* <p class="bold">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
			</div>
		</header>
		<section class="widgets padding-0 margin-0 container-bg">

            <div class="widget-header widget-header-checkin-inner">
                { props.currentWidgetObj.widgetHeaderImageUrl && 
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title" dangerouslySetInnerHTML={{__html: t("check_in.gdprBeforeIdAndSelfieScan.heading") }}></div>
            </div>

			<div class="widgets">
				<div class="form-window">
					<div class="form-window-heading">
						{/* {t("check_in.gdprBeforeIdAndSelfieScan.heading")} */}
					</div>
					<div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
						<div  class="preview-text">

                            {verbiage && verbiage.map(item=>{
                                switch(item.type){
                                    case "text":
                                        return  <div key={item.order} dangerouslySetInnerHTML={{__html: item.text}}></div>
                                    case "question":
                                         return <div key={item.order}>
                                        <p dangerouslySetInnerHTML={{__html: item.questionText}} ></p>
                                        <div class="optgroup">
                                            {
                                                item.questionOptions.map(option=>{
                                                    return <p> <input type="radio"  checked={Boolean(option.isSelected)} onClick={()=> handleChangeQuestionRadio(item.order, option.order, option)} /> <span dangerouslySetInnerHTML={{__html: option.text  }}></span> </p>
                                                })
                                            }
                                        </div>   
                               
                                </div>  
                                
                                }
                            })}
							 
							</div>
						</div>
						<div class="form-controls">
                            {
                            allowProceedButton ?
                                <button class="primary w-100" disabled={!allowProceedButton} onClick={props.proceed}>Proceed</button>
                                :<>
                                     { showWarning && <div style={{color:"red", marginBottom:"1rem"}}> * {t("check_in.gdprBeforeIdAndSelfieScan.warningAtFD")} </div>}
                                    <button class="primary w-100" onClick={props.goBack}>Close</button>
                                </>
                             }
							 
						</div>
					</div>
				</div>
				
		</section>
	</div>
  )
}

const mapStateToProps = (state, props) => {
    return {
        survey: state.store.survey,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
    }
}

export default connect(mapStateToProps, {getSurvey, sendAnalytics})(withTranslation('translations')(GdprBeforeIdAndSelfieScan));